{
  "removeButtonLabel": "Odebrat",
  "removeDescription": "Stisknutím klávesy Delete odeberete značku."
}
